import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useNavigate } from 'react-router-dom';
import './FireSafetyDashboard.css';

const sectionLinks = {
  fireAlarms: '/properties/:id/fire-safety/fire-alarms',
  sprinklers: '/properties/:id/fire-safety/sprinklers',
  emergencyLights: '/properties/:id/fire-safety/emergency-lights',
  fireDoors: '/properties/:id/fire-safety/fire-doors',
  fireExtinguishers: '/properties/:id/fire-safety/fire-extinguishers',
  smokeDetectors: '/properties/:id/fire-safety/smoke-detectors',
  heatDetectors: '/properties/:id/fire-safety/heat-detectors',
};

const FireSafetyAlerts = ({ open, onClose, alerts, propertyId }) => {
  const navigate = useNavigate();

  if (!open) return null;

  return (
    <div className="alerts-modal-overlay">
      <div className="alerts-modal">
        <div className="alerts-modal-header">
          <h3>Fire Safety Alerts</h3>
          <button className="close-btn" onClick={onClose}>×</button>
        </div>
        <ul className="alerts-list">
          {alerts.length === 0 ? (
            <li className="no-alerts">No issues found.</li>
          ) : (
            alerts.map(item => (
              <li
                key={item.key}
                className="alert-item"
                onClick={() => navigate(sectionLinks[item.key].replace(':id', propertyId))}
                style={{ cursor: 'pointer' }}
              >
                <FontAwesomeIcon icon={item.icon} className="alert-icon" />
                <span className="alert-label">{item.label}:</span>
                <span className="alert-failed">{item.failed} Failed</span>
              </li>
            ))
          )}
        </ul>
      </div>
    </div>
  );
};

export default FireSafetyAlerts; 